import { ModuleResourceRowDTO } from "../../ProfileWindow/AdminWindows/ModuleEditWindow/DTO/ModuleResourceRowDTO";
import { ModuleResponseApi } from "../ServerResponseType/Module/Module";
import {
  ModuleResourcePropApi,
  ModuleResourceWithScenarioOrMaterialResponseApi,
} from "../ServerResponseType/Module/ModuleResource";

export interface ModuleWithResourcesAndTasksRequestApi
  extends ModuleResponseApi {
  moduleResources: ModuleResourcePropApi[];
}

export class ModuleWithResourcesAndTasksRequestImpl
  implements ModuleWithResourcesAndTasksRequestApi
{
  moduleId: string;
  moduleName: string;
  moduleResources: ModuleResourcePropApi[];

  constructor(module: ModuleWithResourcesAndTasksRequestApi) {
    this.moduleId = module.moduleId;
    this.moduleName = module.moduleName;
    this.moduleResources = module.moduleResources;
  }
}

export class ModuleResourceRequestImpl implements ModuleResourcePropApi {
  moduleResourceId?: string;
  order?: number;
  required?: boolean;
  resourceId?: string;
  taskId?: string;

  constructor(
    moduleResource:
      | ModuleResourceWithScenarioOrMaterialResponseApi
      | ModuleResourceRowDTO
  ) {
    this.moduleResourceId = moduleResource.moduleResourceId;
    this.resourceId = moduleResource.resourceId;
    this.taskId = moduleResource.taskId;
    this.order = moduleResource.order;
    this.required = moduleResource.required;
  }
}
